import { Injectable } from "@angular/core";
import { type AbstractControl, type FormGroup, FormBuilder, Validators } from "@angular/forms";
import type { ILoginFormInput } from "@core-ports/inputs/login";
import type { FormErrorMap } from "@core-ports/outputs/forms/base";
import { BaseFormFactory } from "@infra-adapters/forms/base";


@Injectable({
    providedIn: 'root'
})
export class LoginFormFactory extends BaseFormFactory<ILoginFormInput> {

    constructor(private fb: FormBuilder) {
        super();
    }

    generateForm(): FormGroup<ILoginFormInput> {
        return this.fb.group({
            email: this.fb.control<string | null>(null, {
                nonNullable: false,
                validators: [Validators.required, Validators.email]
            }),
            password: this.fb.control<string | null>(null, {
                nonNullable: false,
                validators: [Validators.required, Validators.minLength(6)]
            }),
        });
    }

    protected getErrorMap(control: AbstractControl): FormErrorMap<ILoginFormInput> {
        return {
            _default: {
                required: 'Este campo es obligatorio.',
                email: 'Ingresa un correo electrónico válido.',
                minlength: `Debe tener al menos ${control.errors?.['minlength']?.requiredLength} caracteres.`,
            }
        }
    }
}